export const TRANSLATIONS = {
    EN: {
        JOBS: {
            GLOBAL: {
                INTAKE_COMPLETED: 'Intake completed',
                JOBS_DESCRIPTION: 'Jobs descriptions',
                OTHER_REQUESTS: 'Other requests',
                DAY_PREFERENCE: 'Client day time preferences:',
                CONSENT_INFORMATION: 'I confirm this time is correct.',
                CONFIRM_APPOINTMENT: 'Confirm appointment',
                APPOINTMENT_DATE: 'The appointment is set to:',
                URGENCY: 'Urgency',
                LANGUAGE_OPTIONS: 'Language options',
                EDIT_QUOTE: 'Edit quote',
                CANCEL_QUOTE: 'Cancel quote',
                CREATE_QUOTE: 'Create quote',
                SUBMIT_QUOTE: 'Submit invoice',
                SEND_INVOICE: 'Send invoice',
                RESET_CHANGES: 'Reset changes',
                COMPANY_DOCUMENTS: 'Upload required documents for the application',
                DUPLICATED_SHAREHOLDER: 'Seems that this shareholder is already added.',
                OPTIONAL_MESSAGE: 'All uploads are optional',
                UPLOAD_MESSAGE:
                    'Upload the required documents in this upload box. You can upload multiple documents. Then select the appropriate category of the document.',
                AGREEMENT_MESSAGE_1:
                    'You want to proceed to the next step. In the next step, the service provider will take action. To make the procedure as efficient as possible, you can start the necessary identification or upload the documents.',
                AGREEMENT_MESSAGE_2: 'Is it true that you can proceed without completing identification or uploading documents?',
                CONFIRM_JOB_DONE: 'Confirm that all results have been uploaded and that the job is finally completed.',
                NOT_YET_INCORPORATED: 'Organization not yet incorporated',
                CANCELLED_APPLICATION: 'Cancel application',
                CHOOSE_SERVICE_PROVIDER: 'Choose service provider',
                APPLICATION_FOR: 'Application for {name}',
                ACCEPT_APPLICATION_CONFIRMATION: 'Are you sure you want to accept this application?',
                DECLINE_APPLICATION_CONFIRMATION: 'Are you sure you want to decline this application?',
                CANCEL_QUOTE_CONFIRMATION: 'Are you sure you want to withdraw this quote?',
                UPLOAD_RESULT_CONFIRMATION: 'Are you sure you want to send this result?',
                COMPLETE_JOB_CONFIRMATION: 'Are you sure you want to complete this application?',
                APPROVE_MILESTONE_CONFIRMATION: 'Are you sure you want to approve this milestone? This cannot be undone.',
                PREFERRED_DATES: 'Client preferred intake dates',
                SERVICE_PROVIDER: 'service provider',
                BUSY_QUESTION_1: 'Does the job (or part of it) have to be completed before a certain date?',
                BUSY_QUESTION_2: 'Before which date?',
                BUSY_QUESTION_3: 'What is the reason for this date?',
                NO_SP_SELECTED: 'Please select a service provider',
            },
            DETAILS: {
                PAGE_TITLE: 'What kind of {job} job do you need?',
                PAGE_DESCRIPTION: 'Select one or more options. You can request multiple jobs at the same time, from the same service provider.',
            },
            PAYMENT: {
                PAGE_TITLE: 'Overview of your order',
                DESCRIPTION:
                    'In order to process your application as quickly and efficiently as possible, an intake interview with the service provider is necessary.',
                LIST: {
                    ITEM_1: 'In the intake interview, the service provider discusses the desired change, the necessary steps and when everything can be arranged.',
                    ITEM_2: 'The costs for the intake interview (+/- 30 minutes) are {price} ex VAT.',
                    ITEM_3: 'These costs are then deducted from the total costs of the desired change. The intake interview therefore does not entail any additional costs.',
                    ITEM_4: 'After payment, the service provider will contact you within 48 hours to schedule the intake interview.',
                },
                INTAKE_PRODUCT: 'Intake',
                PAGE_SUB_TITLE: 'Overview',
            },
            REFERENCES_ADJECTIVE: {
                TAX: 'tax',
                NOTARY: 'notary',
                LEGAL: 'legal',
                CORPORATE_SERVICES: 'corporate service',
            },
            REASON_FOR_DECLINE: {
                TITLE: 'Select a reason for the decline',
                DESCRIPTION: 'Reason for decline. I cannot accept this job because:',
                OPTIONS: {
                    NOT_AUTHORIZED: 'I am not authorized to perform this job',
                    AGAINST_RULES: 'This job goes against professional rules or legislation',
                    NO_TIME: "I don't have time to do this job",
                    OTHER: 'Otherwise, namely',
                    UNDEFINED: 'Reason not provided',
                },
                FOR_COMPLETENESS: 'For completeness, please provide more information so that the {tenant} team can process this request',
            },
            DECLINE_MILESTONE: {
                TITLE: 'Select the option for the rejection',
                REASON_REJECTION: 'Reason for rejection',
                DESCRIPTION: 'Reason for decline. I cannot accept this milestone because:',
                OPTIONS: {
                    NOT_COMPLETED: 'Result is not complete',
                    AGAINST_RULES: 'Result is wrong or missing',
                    NO_QUALITY: 'The quality of the result is substandard',
                    OTHER: 'Otherwise, namely',
                },
            },
            MILESTONE_STEPS: {
                NEW: {
                    CLIENT: {
                        DESCRIPTION:
                            'The milestone has been paid. The service provider is now performing the service. As soon as it has completed the milestone, the service provider will upload the result. You will then receive a notification for reviewing the milestone.',
                    },
                    BOOKKEEPER: {
                        DESCRIPTION:
                            'The milestone has been paid. The service provider is now performing the service. As soon as it has completed the milestone, the service provider will upload the result. You will then receive a notification for reviewing the milestone.',
                    },
                    NOTARY: {
                        DESCRIPTION:
                            'To complete the current milestone, add the milestone description and upload the results. The client will receive a notification per email to review the milestone. After approval, this milestone will be paid out.',
                    },
                    SUPPORT: {
                        DESCRIPTION:
                            'To complete the current milestone, add the milestone description and upload the results. The client will receive a notification per email to review the milestone. After approval, this milestone will be paid out.',
                    },
                },
                SUBMITTED: {
                    CLIENT: {
                        DESCRIPTION:
                            'The service provider has completed the milestone and uploaded the result. You can view and download it below. You can then approve or reject the result. If you reject the milestone, you can then provide your feedback. Please note: you have a period of 5 working days to assess the milestone. After that, the milestone is automatically released and the amount paid to the service provider.',
                    },
                    BOOKKEEPER: {
                        DESCRIPTION:
                            'The service provider has completed the milestone and uploaded the result. You can view and download it below. You can then approve or reject the result. If you reject the milestone, you can then provide your feedback. Please note: you have a period of 5 working days to assess the milestone. After that, the milestone is automatically released and the amount paid to the service provider.',
                    },
                    NOTARY: {
                        DESCRIPTION: 'The result has been uploaded. The client receives an email notification to review the milestone.',
                    },
                    SUPPORT: {
                        DESCRIPTION: 'The result has been uploaded. The client receives an email notification to review the milestone.',
                    },
                },
                APPROVED: {
                    CLIENT: {
                        DESCRIPTION: 'The result of the milestone has been approved by you.',
                    },
                    BOOKKEEPER: {
                        DESCRIPTION: 'The result of the milestone has been approved by you.',
                    },
                    NOTARY: {
                        DESCRIPTION: 'The result of the milestone has been approved by the client.',
                    },
                    SUPPORT: {
                        DESCRIPTION: 'The result of the milestone has been approved by the client.',
                    },
                },
                REJECTED: {
                    CLIENT: {
                        DESCRIPTION:
                            'The result for the milestone has been rejected. The service provider has received the feedback and will take action on it. The feedback for the rejection is:',
                    },
                    BOOKKEEPER: {
                        DESCRIPTION:
                            'The result for the milestone has been rejected. The service provider has received the feedback and will take action on it. The feedback for the rejection is:',
                    },
                    NOTARY: {
                        DESCRIPTION:
                            'The result of the milestone has been rejected. Contact the client to adjust the result. The feedback for the rejection is:',
                    },
                    SUPPORT: {
                        DESCRIPTION:
                            'The result of the milestone has been rejected. Contact the client to adjust the result. The feedback for the rejection is:',
                    },
                },
            },
            ASSIGN_PROVIDER: {
                DESCRIPTION:
                    'The service provider rejected the application. View the reason for the rejection. You can submit the request to another service provider or cancel the request. The applicant will automatically receive an email.',
                REASON_REJECTION: 'This is the reason for the rejection:',
                EXTRA_INFORMATION: 'For completeness, provided more information:',
            },
            APPLICATION_REJECTED: {
                TITLE: 'The application has been rejected by the service provider',
                DESCRIPTION: "The service provider rejected the application. {tenant}'s support team will review the rejection within 24 hours",
            },
            APPLICATION_CANCELLED: {
                TITLE: 'The application has been canceled',
                DESCRIPTION: 'The service provider rejected the application and the application was canceled. The reason for the cancellation is:',
            },
            APPLICATION_COMPLETED: 'The procedure is complete. You can find the information and download the documents here. The chat is disabled.',
            REFERENCES: {
                CHANGE_COMPANY: 'Change company',
                OTHER: 'Other',
                INTERNATIONAL: 'International',
                VAT: 'Vat',
                TAX: 'Tax',
                NOTARY: 'Notary',
                LEGAL: 'Legal',
                CORPORATE_SERVICES: 'Corporate Services',
                TAX_COMPLIANCE: 'Tax compliance',
                CORPORATE_AND_BUSINESS_LAW: 'Corporate and business law',
                DISPUTES: 'Disputes',
                GENERAL: 'General',
                CONTRACTS: 'Contracts',
                IDENTIFICATION: 'Identification',
                INCORPORATION: 'Incorporation',
                UBO: 'Ubo',
                LEGAL_FORMS_ABROAD: 'Legal forms abroad',
                TRANSFER_PRICING: 'Transfer pricing',
                SETTING_UP_INVESTMENT_STRUCTURES: 'Setting up investment_structures',
                WORKING_ACROSS_BORDERS: 'Working across borders',
                SOCIAL_SECURITY_INTERNATIONAL: 'Social security international',
                EMIGRATION_REMIGRATION: 'Emigration remigration',
                INTERNATIONAL_GROUP_FINANCING: 'International group_financing',
                REAL_ESTATE_AND_VAT_RETURN: 'Real estate and vat return',
                VAT_EXEMPTIONS: 'Vat exemptions',
                RIGHT_TO_VAT_DEDUCTION: 'Right to vat deduction',
                CROSS_BORDER_DELIVERIES_OF_GOODS: 'Cross border deliveries of goods',
                INTERNATIONAL_SERVICES: 'International services',
                VAT_SCAN: 'Vat scan',
                EC_SALES_LISTS: 'Ec sales lists',
                INTRASTAT_REPORTS: 'Intrastat reports',
                CORPORATE_TAX_RETURN: 'Corporate tax return',
                INCOME_TAX_RETURN: 'Income tax return',
                SETTING_UP_TAX_CONTROL_FRAMEWORK: 'Setting up tax control framework',
                MERGERS_ACQUISITIONS: 'Mergers acquisitions',
                JOINT_VENTURES: 'Joint ventures',
                COLLABORATION_AGREEMENTS: 'Collaboration agreements',
                SHAREHOLDER_AGREEMENTS: 'Shareholder agreements',
                COMPANY_AGREEMENTS: 'Company agreements',
                SETTING_UP_LEGAL_ENTITIES: 'Setting up legal entities',
                RESTRUCTURING: 'Restructuring',
                CORPORATE_GOVERNANCE: 'Corporate governance',
                SHAREHOLDER_DISPUTES: 'Shareholder disputes',
                DISPUTE_RESOLUTION_WITHDRAWAL_OR_EXPULSION_OF_SHAREHOLDERS: 'Dispute resolution withdrawal or expulsion of shareholders',
                DISPUTES_BETWEEN_PARTNERS_OF_A_VOF_OR_PARTNERSHIP: 'Disputes between partners of a vof or partnership',
                ENTERPRISE_CHAMBER_INQUIRY_LAW: 'Enterprise chamber inquiry law',
                DIRECTORS_LIABILITY: 'Directors liability',
                TRADEMARK_REGISTRATION: 'Trademark registration',
                REQUEST_A30_RULING: 'Request a30 ruling',
                HSM_VISA: 'Hsm visa',
                HAVE_CONTRACTS_CHECKED: 'Have contracts checked',
                HAVE_CONTRACTS_DRAWN_UP_CUSTOMISED: 'Have contracts drawn up customised',
                LEGALIZATION: 'Legalization',
                APOSTILLE: 'Apostille',
                SHARE_ISSUE: 'Share issue',
                SHARE_MERGER: 'Share merger',
                SHARE_TRANSFER: 'Share transfer',
                CERTIFICATION_SHARES: 'Certification shares',
                AMENDMENT_OF_THE_ARTICLES_OF_ASSOCIATION: 'Amendment of the articles of association',
                AMENDMENT_OF_THE_ARTICLES_OF_ASSOCIATION_CATEGORY1: 'Amendment of the articles of association category 1',
                AMENDMENT_OF_THE_ARTICLES_OF_ASSOCIATION_CATEGORY2: 'Amendment of the articles of association category 2',
                AMENDMENT_OF_THE_ARTICLES_OF_ASSOCIATION_CATEGORY3: 'Amendment of the articles of association category 3',
                AMENDMENT_OF_THE_ARTICLES_OF_ASSOCIATION_CATEGORY4: 'Amendment of the articles of association category 4',
                STAMPING_SHARE_CAPITAL: 'Stamping share capital',
                TAX_FREE_DISTRIBUTION_OF_SHARE_PREMIUM_RESERVE: 'Tax free distribution of share premium reserve',
                LEGAL_MERGER: 'Legal merger',
                LEGAL_SEPARATION: 'Legal separation',
                INCORPORATION_OF_A_NV: 'Incorporation of a nv',
                INCORPORATION_OF_A_BV_CUSTOMIZED_ARTICLES_OF_ASSOCIATION: 'Incorporation of a bv customized articles of association',
                INCORPORATION_OF_A_BV_CUSTOMIZED_SHARES: 'Incorporation of a bv customized shares',
                INCORPORATION_OF_A_BV_FOREIGN_COMPANY_AS_SHAREHOLDER: 'Incorporation of a bv foreign company as shareholder',
                INCORPORATION_OF_ASSOCIATION: 'Incorporation of association',
                INCORPORATION_OF_COOPERATIVE: 'Incorporation of cooperative',
                INCORPORATION_OF_FOUNDATION_CUSTOMIZED_STATUTES: 'Incorporation of foundation customized statutes',
                INCORPORATION_OF_PARTNERSHIP: 'Incorporation of partnership',
                INCORPORATION_OF_STAK: 'Incorporation of stak',
                UBO_CHANGE: 'Ubo change',
                UBO_STATEMENT: 'Ubo statement',
                UBO_REGISTRATION: 'Ubo registration',
                DISPUTES_BETWEEN_PARTNERS_OF_A_V_O_F_OR_PARTNERSHIP: 'Disputes between partners of a V.O.F. or partnership',
                REQUEST_A_30_RULING: 'Request a 30% ruling',
            },
            STEPS: {
                INTAKE_INTERVIEW: {
                    SCHEDULED_FOR: 'The intake interview has been scheduled for',
                    CLIENT: {
                        CONTACT_AGREED_TIME: 'The service provider will contact you at the agreed time and discuss the desired service.',
                    },
                    SERVICE_PROVIDER: {
                        POINT_1: 'Contact the client at the agreed time and discuss the desired service.',
                        POINT_2: 'Is everything clear? Go ahead and prepare the quote.',
                        POINT_3: 'If the request does not fit within the service, you can cancel it. {tenant} then takes over the process.',
                        REQUIRE_IDENTIFICATION: 'Does this process require identification?',
                        REQUIRE_DOCUMENTS: 'Does this process require documents?',
                    },
                },
                VERIFY_ORGANIZATION: {
                    CLIENT: {
                        DOCUMENTS_REQUIRED: 'The service provider request the following documents to complete the job',
                    },
                },
            },
        },
    },
    NL: {
        JOBS: {
            GLOBAL: {
                INTAKE_COMPLETED: 'Intake afgerond',
                JOBS_DESCRIPTION: 'Job beschrijving',
                OTHER_REQUESTS: 'Overige aanvragen',
                DAY_PREFERENCE: 'Client(s) voorkeur dag en tijdstip:',
                CONSENT_INFORMATION: 'Ik bevestig dat het tijstip correct is.',
                CONFIRM_APPOINTMENT: 'Bevestig afspraak',
                APPOINTMENT_DATE: 'De afspraak staat op:',
                URGENCY: 'Urgentie',
                LANGUAGE_OPTIONS: 'Taal opties',
                EDIT_QUOTE: 'Offerte aanpassen',
                CANCEL_QUOTE: 'Offerte annuleren',
                CREATE_QUOTE: 'Offerte opstellen',
                SUBMIT_QUOTE: 'Factuur indienen',
                SEND_INVOICE: 'Factuur versturen',
                RESET_CHANGES: 'Wijzigingen resetten',
                COMPANY_DOCUMENTS: 'Upload benodigde documenten voor de opdracht',
                DUPLICATED_SHAREHOLDER: 'Het lijkt erop dat deze aandeelhouder al is toegevoegd.',
                OPTIONAL_MESSAGE: 'Alle uploads zijn optioneel',
                UPLOAD_MESSAGE:
                    'Upload de benodigde documenten in deze uploadbox. U kunt meerdere documenten uploaden. Selecteer daarna de juiste categorie van het document.',
                AGREEMENT_MESSAGE_1:
                    'U wilt doorgaan naar de volgende stap. Bij de volgende stap gaat de dienstverlener in actie komen. Om de procedure zo efficiënt te laten verlopen, kunt u nog de benodigde identificatie starten of de documenten uploaden.',
                AGREEMENT_MESSAGE_2: 'Klopt het dat u door kunt gaan zonder identificatie te voltooien of documenten te uploaden?',
                CONFIRM_JOB_DONE: 'Bevestig dat alle resultaten zijn geüpload en dat de job definitief is voltooid.',
                NOT_YET_INCORPORATED: 'Onderneming nog niet opgericht',
                CANCELLED_APPLICATION: 'Aanvraag annuleren',
                CHOOSE_SERVICE_PROVIDER: 'Kies dienstverlener',
                APPLICATION_FOR: 'Aanvraag voor {name}',
                ACCEPT_APPLICATION_CONFIRMATION: 'Weet u zeker dat u deze aanvraag wilt accepteren?',
                DECLINE_APPLICATION_CONFIRMATION: 'Weet u zeker dat u deze opdracht wilt afwijzen?',
                CANCEL_QUOTE_CONFIRMATION: 'Weet u zeker dat u deze offerte wilt intrekken?',
                UPLOAD_RESULT_CONFIRMATION: 'Weet u zeker dat u dit resultaat wilt versturen?',
                COMPLETE_JOB_CONFIRMATION: 'Weet u zeker dat u deze opdracht wilt afronden?',
                APPROVE_MILESTONE_CONFIRMATION: 'Weet u zeker dat u dit resultaat wilt goedkeuren? Dit kan niet ongedaan worden gemaakt.',
                PREFERRED_DATES: 'Cliënt voorkeursdatum(s) voor intake',
                SERVICE_PROVIDER: 'dienstverlener',
                BUSY_QUESTION_1: 'Dient de opdracht (of een gedeelte) voor een bepaalde datum afgerond te zijn?',
                BUSY_QUESTION_2: 'Voor welke datum?',
                BUSY_QUESTION_3: 'Wat is de reden voor deze datum?',
                NO_SP_SELECTED: 'Selecteer een dienstverlener',
            },
            DETAILS: {
                PAGE_TITLE: 'Welke soort {job} job heeft u nodig',
                PAGE_DESCRIPTION: 'Selecteer éen of meer opties. U kunt meerdere opdrachten tegelijkertijd aanvragen bij dezelfde dienstverlener.',
            },
            PAYMENT: {
                PAGE_TITLE: 'Overzicht van uw bestelling',
                DESCRIPTION: 'Om uw aanvraag zo snel en efficiënt mogelijk te kunnen behandelen is een intakegesprek met de dienstverlener nodig.',
                LIST: {
                    ITEM_1: 'In het intakegesprek bespreekt de dienstverlener de gewenste wijziging, de benodigde stappen en op welk termijn alles geregeld kan worden.',
                    ITEM_2: 'De kosten voor het intakegesprek (+/- 30 minuten) bedragen {price} ex btw.',
                    ITEM_3: 'Deze kosten worden vervolgens in mindering gebracht op de totale kosten van de gewenste wijziging. Het intakegesprek brengt dus geen extra kosten met zich mee.',
                    ITEM_4: 'Na betaling neemt de service provider binnen 48 uur contact op om het intakegesprek in te plannen.',
                },
                INTAKE_PRODUCT: 'Intakegesprek',
                PAGE_SUB_TITLE: 'Overzicht',
            },
            REFERENCES_ADJECTIVE: {
                TAX: 'fiscale',
                NOTARY: 'notariële',
                LEGAL: 'juridische',
                CORPORATE_SERVICES: 'corporate service',
            },
            REASON_FOR_DECLINE: {
                TITLE: 'Selecteer een reden voor de afwijzing',
                DESCRIPTION: 'Reden voor afwijzing. Ik kan deze job niet accepteren omdat:',
                OPTIONS: {
                    NOT_AUTHORIZED: 'Ik niet bevoegd ben om deze job uit te voeren',
                    AGAINST_RULES: 'Deze job ingaat tegen de beroepsregels of wetgeving',
                    NO_TIME: 'Ik geen tijd heb om deze job uit te voeren',
                    OTHER: 'Anders, namelijk',
                    UNDEFINED: 'Reden niet opgegeven',
                },
                FOR_COMPLETENESS: 'Geef voor de volledigheid meer informatie zodat het {tenant} team deze aanvraag kan afwikkelen',
            },
            DECLINE_MILESTONE: {
                TITLE: 'Selecteer een reden voor de afwijzing',
                REASON_REJECTION: 'Reden voor afwijzing',
                DESCRIPTION: 'Reden voor afwijzing. Ik kan deze job niet accepteren omdat:',
                OPTIONS: {
                    NOT_COMPLETED: 'Het resultaat is niet volledig',
                    AGAINST_RULES: 'Het resultaat is verkeerd of ontbreekt',
                    NO_QUALITY: 'De kwaliteit van het resultaat is ondermaats',
                    OTHER: 'Anders, namelijk…',
                },
            },
            MILESTONE_STEPS: {
                NEW: {
                    CLIENT: {
                        DESCRIPTION:
                            'De milestone is betaald. De dienstverlener is nu aan de slag met het uitvoeren van de dienst. Zodra deze de milestone heeft afgerond, zal de dienstverlener het resultaat uploaden. Vervolgens ontvangt u een notificatie voor het reviewen van de milestone.',
                    },
                    BOOKKEEPER: {
                        DESCRIPTION:
                            'De milestone is betaald. De dienstverlener is nu aan de slag met het uitvoeren van de dienst. Zodra deze de milestone heeft afgerond, zal de dienstverlener het resultaat uploaden. Vervolgens ontvangt u een notificatie voor het reviewen van de milestone.',
                    },
                    NOTARY: {
                        DESCRIPTION:
                            'Om de huidige milestone te voltooien, voeg de milestone beschrijving toe en upload de resultaten. De klant ontvangt per e-mail een melding om de milestone te reviewen. Na goedkeuring wordt deze milestone uitbetaald.',
                    },
                    SUPPORT: {
                        DESCRIPTION:
                            'Om de huidige milestone te voltooien, voeg de milestone beschrijving toe en upload de resultaten. De klant ontvangt per e-mail een melding om de milestone te reviewen. Na goedkeuring wordt deze milestone uitbetaald.',
                    },
                },
                SUBMITTED: {
                    CLIENT: {
                        DESCRIPTION:
                            'De dienstverlener heeft de milestone afgerond en het resultaat geupload. Deze kun je hieronder inzien en downloaden. Vervolgens kun je het resultaat goedkeuren of afkeuren. Indien je de milestone afkeurt, kun je vervolgens je feedback opgeven. Let op: je hebt een periode van 5 werkdagen om de milestone te beoordelen. Daarna wordt de milestone automatisch vrijgegeven en het bedrag uitgekeerd aan de dienstverlener.',
                    },
                    BOOKKEEPER: {
                        DESCRIPTION:
                            'De dienstverlener heeft de milestone afgerond en het resultaat geupload. Deze kun je hieronder inzien en downloaden. Vervolgens kun je het resultaat goedkeuren of afkeuren. Indien je de milestone afkeurt, kun je vervolgens je feedback opgeven. Let op: je hebt een periode van 5 werkdagen om de milestone te beoordelen. Daarna wordt de milestone automatisch vrijgegeven en het bedrag uitgekeerd aan de dienstverlener.',
                    },
                    NOTARY: {
                        DESCRIPTION: 'Het resultaat is geupload. De klant ontvangt per e-mail een melding om de milestone te reviewen.',
                    },
                    SUPPORT: {
                        DESCRIPTION: 'Het resultaat is geupload. De klant ontvangt per e-mail een melding om de milestone te reviewen.',
                    },
                },
                APPROVED: {
                    CLIENT: {
                        DESCRIPTION: 'Het resultaat van de milestone is goedgekeurd door jou.',
                    },
                    BOOKKEEPER: {
                        DESCRIPTION: 'Het resultaat van de milestone is goedgekeurd door jou.',
                    },
                    NOTARY: {
                        DESCRIPTION: 'Het resultaat van de milestone is goedgekeurd door de cliënt.',
                    },
                    SUPPORT: {
                        DESCRIPTION: 'Het resultaat van de milestone is goedgekeurd door de cliënt.',
                    },
                },
                REJECTED: {
                    CLIENT: {
                        DESCRIPTION:
                            'Het resultaat voor de milestone is afgewezen. De dienstverlener heeft de feedback ontvangen en zal hierop actie uitvoeren. De feedback voor de afwijzing is:',
                    },
                    BOOKKEEPER: {
                        DESCRIPTION:
                            'Het resultaat voor de milestone is afgewezen. De dienstverlener heeft de feedback ontvangen en zal hierop actie uitvoeren. De feedback voor de afwijzing is:',
                    },
                    NOTARY: {
                        DESCRIPTION:
                            'Het resultaat van de milestone is afgewezen. Neem contact op met de cliënt om het resultaat aan te passen. De feedback voor de afwijzing is:',
                    },
                    SUPPORT: {
                        DESCRIPTION:
                            'Het resultaat van de milestone is afgewezen. Neem contact op met de cliënt om het resultaat aan te passen. De feedback voor de afwijzing is:',
                    },
                },
            },
            ASSIGN_PROVIDER: {
                DESCRIPTION:
                    'De dienstverlener heeft de aanvraag afgewezen. Bekijk de reden van de afwijzing. Je kunt de aanvraag bij een andere dienstverlener neerleggen of de aanvraag annuleren. De aanvrager krijgt automatisch een e-mail.',
                REASON_REJECTION: 'Dit is de reden voor de afwijzing:',
                EXTRA_INFORMATION: 'Geef voor de volledigheid meer informatie:',
            },
            APPLICATION_REJECTED: {
                TITLE: 'De aanvraag is afgewezen door de dienstverlener',
                DESCRIPTION: 'De dienstverlener heeft de aanvraag afgewezen. Het support team van {tenant} beoordeelt de afwijzing binnen 24 uur.',
            },
            APPLICATION_CANCELLED: {
                TITLE: 'De aanvraag is geannuleerd',
                DESCRIPTION: 'De dienstverlener heeft de aanvraag afgewezen en de aanvraag is geannuleerd. De reden voor de annulering is:',
            },
            APPLICATION_COMPLETED: 'De procedure is voltooid. U kunt hier de informatie vinden en de documenten downloaden. De chat is uitgeschakeld.',
            REFERENCES: {
                CHANGE_COMPANY: 'Wijzigen onderneming',
                OTHER: 'Overig',
                INTERNATIONAL: 'Internationaal',
                VAT: 'BTW',
                TAX: 'Fiscaal',
                NOTARY: 'Notarieel',
                LEGAL: 'Juridisch',
                CORPORATE_SERVICES: 'Corporate Services',
                TAX_COMPLIANCE: 'Fiscale compliance',
                CORPORATE_AND_BUSINESS_LAW: 'Vennootschaps- en ondernemingsrecht',
                DISPUTES: 'Geschillen',
                GENERAL: 'Algemeen',
                CONTRACTS: 'Contracten',
                IDENTIFICATION: 'Identificatie',
                INCORPORATION: 'Oprichting',
                UBO: 'Ubo',
                LEGAL_FORMS_ABROAD: 'Rechtsvormen in het buitenland',
                TRANSFER_PRICING: 'Transfer pricing',
                SETTING_UP_INVESTMENT_STRUCTURES: 'Investeringstructuren opzetten',
                WORKING_ACROSS_BORDERS: 'Grensoverschrijdend werken',
                SOCIAL_SECURITY_INTERNATIONAL: 'Sociale zekerheid (internationaal)',
                EMIGRATION_REMIGRATION: 'Emigratie remigratie',
                INTERNATIONAL_GROUP_FINANCING: 'Internationale groepsfinanciering',
                REAL_ESTATE_AND_VAT_RETURN: 'Vastgoed en BTW-aangifte',
                VAT_EXEMPTIONS: 'BTW-vrijstellingen',
                RIGHT_TO_VAT_DEDUCTION: 'Recht op btw-aftrek',
                CROSS_BORDER_DELIVERIES_OF_GOODS: 'Grensoverschrijdende leveringen van goederen',
                INTERNATIONAL_SERVICES: 'Internationale dienstverlening',
                VAT_SCAN: 'BTW scan',
                EC_SALES_LISTS: 'EG verkooplijsten',
                INTRASTAT_REPORTS: 'Intrastat rapporten',
                CORPORATE_TAX_RETURN: 'Aangifte vennootschapsbelasting',
                INCOME_TAX_RETURN: 'Aangifte inkomstenbelasting',
                SETTING_UP_TAX_CONTROL_FRAMEWORK: 'Inrichten Tax Controle Framework',
                MERGERS_ACQUISITIONS: 'Fusies en overnames',
                JOINT_VENTURES: 'Joint ventures',
                COLLABORATION_AGREEMENTS: 'Samenwerkingsovereenkomsten',
                SHAREHOLDER_AGREEMENTS: 'Aandeelhoudersovereenkomsten',
                COMPANY_AGREEMENTS: 'Vennootschapsovereenkomsten',
                SETTING_UP_LEGAL_ENTITIES: 'Opzetten van rechtspersonen',
                RESTRUCTURING: 'Herstructureringen',
                CORPORATE_GOVERNANCE: 'Ondernemingsbestuur',
                SHAREHOLDER_DISPUTES: 'Aandeelhoudersgeschillen',
                DISPUTE_RESOLUTION_WITHDRAWAL_OR_EXPULSION_OF_SHAREHOLDERS: 'Geschillenregeling (uittreding of uitstoting van aandeelhouders)',
                DISPUTES_BETWEEN_PARTNERS_OF_A_VOF_OR_PARTNERSHIP: 'Geschillen tussen vennoten van een V.O.F. of maatschap',
                ENTERPRISE_CHAMBER_INQUIRY_LAW: 'Ondernemingskamer (enquêterecht)',
                DIRECTORS_LIABILITY: 'Bestuurdersaansprakelijkheid',
                TRADEMARK_REGISTRATION: 'Merkrechtregistratie',
                REQUEST_A30_RULING: '30% ruling aanvragen',
                HSM_VISA: 'HSM VISA',
                HAVE_CONTRACTS_CHECKED: 'Contracten laten controleren',
                HAVE_CONTRACTS_DRAWN_UP_CUSTOMISED: 'Contracten laten opstellen (maatwerk)',
                LEGALIZATION: 'Legalisatie',
                APOSTILLE: 'Apostille',
                SHARE_ISSUE: 'Aandelen uitgifte',
                SHARE_MERGER: 'Aandelenfusie',
                SHARE_TRANSFER: 'Aandelenoverdracht',
                CERTIFICATION_SHARES: 'Certificering aandelen',
                AMENDMENT_OF_THE_ARTICLES_OF_ASSOCIATION: 'Statutenwijziging',
                AMENDMENT_OF_THE_ARTICLES_OF_ASSOCIATION_CATEGORY1: 'Statutenwijziging category 1',
                AMENDMENT_OF_THE_ARTICLES_OF_ASSOCIATION_CATEGORY2: 'Statutenwijziging category 2',
                AMENDMENT_OF_THE_ARTICLES_OF_ASSOCIATION_CATEGORY3: 'Statutenwijziging category 3',
                AMENDMENT_OF_THE_ARTICLES_OF_ASSOCIATION_CATEGORY4: 'Statutenwijziging category 4',
                STAMPING_SHARE_CAPITAL: 'Afstempelen aandelenkapitaal',
                TAX_FREE_DISTRIBUTION_OF_SHARE_PREMIUM_RESERVE: 'Onbelast uitkeren agioreserve',
                LEGAL_MERGER: 'Juridische fusie',
                LEGAL_SEPARATION: 'Juridische splitsing',
                INCORPORATION_OF_A_NV: 'Oprichting NV',
                INCORPORATION_OF_A_BV_CUSTOMIZED_ARTICLES_OF_ASSOCIATION: 'Oprichting BV (maatwerk statuten)',
                INCORPORATION_OF_A_BV_CUSTOMIZED_SHARES: 'Oprichting BV (maatwerk aandelen)',
                INCORPORATION_OF_A_BV_FOREIGN_COMPANY_AS_SHAREHOLDER: 'Oprichting BV (door buitenlandse vennootschap)',
                INCORPORATION_OF_ASSOCIATION: 'Oprichting vereniging',
                INCORPORATION_OF_COOPERATIVE: 'Oprichting cooperatie',
                INCORPORATION_OF_FOUNDATION_CUSTOMIZED_STATUTES: 'Oprichting stichting (maatwerk statuten)',
                INCORPORATION_OF_PARTNERSHIP: 'Oprichting maatschap',
                INCORPORATION_OF_STAK: 'Oprichting STAK',
                UBO_CHANGE: 'Ubo wijziging',
                UBO_STATEMENT: 'Ubo verklaring',
                UBO_REGISTRATION: 'Ubo registratie',
                DISPUTES_BETWEEN_PARTNERS_OF_A_V_O_F_OR_PARTNERSHIP: 'Geschillen tussen vennoten van een V.O.F. of maatschap',
                REQUEST_A_30_RULING: '30% ruling aanvragen',
            },
            STEPS: {
                INTAKE_INTERVIEW: {
                    SCHEDULED_FOR: 'Het intakegesprek is ingepland op',
                    CLIENT: {
                        CONTACT_AGREED_TIME: 'De dienstverlener neemt contact op met u op het afgesproken tijdstip en bespreek de gewenste dienstverlening.',
                    },
                    SERVICE_PROVIDER: {
                        POINT_1: 'Neem contact op met de cliënt op het afgesproken tijdstip en bespreek de gewenste dienstverlening.',
                        POINT_2: 'Is alles duidelijk? Ga verder en stel de offerte op.',
                        POINT_3: 'Blijkt de aanvraag niet te passen binnen de dienstverlening, dan kunt u deze annuleren. {tenant} neemt het proces dan over.',
                        REQUIRE_IDENTIFICATION: 'Vereist dit proces identificatie?',
                        REQUIRE_DOCUMENTS: 'Vereist dit proces documenten?',
                    },
                },
                VERIFY_ORGANIZATION: {
                    CLIENT: {
                        DOCUMENTS_REQUIRED: 'De dienstverlener heeft de volgende document nodig om uw aanvraag te kunnen voltooien',
                    },
                },
            },
        },
    },
};
